module.exports = __webpack_public_path__ + "img/blue-banner-4.dee9fe10.svg";